import React from 'react';
import { IconButton as MUIIconButton } from '@material-ui/core';

const IconButton = props => {
    const { size = 24, children, ...restProps } = props;

    return (
        <div
            style={{
            position: "relative",
            height: `${size}px`,
            width: `${size}px`
        }}>
            <MUIIconButton
                style={{
                    position: "absoulute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }}
                {...restProps}
            >
                {children}
            </MUIIconButton>
        </div>
    )
}

export default IconButton;